module.exports = __webpack_public_path__ + "img/returnGameRight.2d3aea60.png";